<ion-searchbar
  *ngIf="state?.canShowMoreValues"
  id="facet-searchbar"
  data-cy="facet-searchbar-input"
  class="facet-search"
  enterkeyhint="search"
  mode="md"
  placeholder="{{ 'i18n.newSearch.searchWithin' | translate }}{{
    state?.displayName
  }}"
  (ionInput)="handleInputChangeFacet($event)"
  (input)="setIsTyping($event)"
  (ionClear)="isTyping = false"
></ion-searchbar>

<ion-accordion value="{{ state?.facetId }}">
  <div slot="content" class="facet-value-list">
    <div class="facet-value-container" *ngIf="showSearchFacet">
      <ion-item
        class="facet-selection-container"
        *ngFor="
          let value of state?.facetSearch?.values;
          let i = index;
          trackBy: trackFacetValueId
        "
      >
        <ion-checkbox
          labelPlacement="start"
          justify="space-between"
          class="facet-selection"
          mode="ios"
          [checked]="value.rawValue === 'selected'"
          (ionChange)="handleCheckboxSelection(value)"
        >
          <span class="facet-value-text">
            {{ value.rawValue | acronymTitleCase | truncateWithEllipsis: 40 }}
          </span>
          <ion-badge mode="ios">
            {{ value.count }}
          </ion-badge>
        </ion-checkbox>
      </ion-item>
    </div>
  </div>
</ion-accordion>

<div
  class="facet-search-empty-result"
  data-cy="facet-search-empty-result"
  *ngIf="showEmptyResult"
>
  <div class="facet-search-empty-msj-1">
    {{ ' We couldn’t find any matches for ' }} {{ '"' + searchText + '"' }}
  </div>
  <div class="facet-search-empty-msj-2">{{ 'Please try again.  ' }}</div>
</div>
